<template>
  <div class="magiccube">
    <div
      :style="{
        background: datas.backColor,
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <!-- <img
      v-if="!showimageList"
      draggable="false"
      src="@/assets/images/defaultPic2.png"
      alt=""
      style="width: 100%"
    /> -->
      <!-- 一行一个 -->
      <section v-if="datas.styleType === 1" class="buju">
        <div class="rubiksCubeType_1" @click="handleClickImg(0)">
          <img
            draggable="false"
            :src="datas.imageList[0] ? datas.imageList[0].imgUrl : defaultImg"
            alt=""
          />
        </div>
      </section>

      <!-- 一行二个 -->
      <section v-if="datas.styleType === 2" class="buju">
        <div
          v-for="index in 2"
          :key="index"
          class="rubiksCubeType_2 rubiksCubeType"
          @click="handleClickImg(index - 1)"
        >
          <img
            draggable="false"
            :src="
              datas.imageList[index - 1]
                ? datas.imageList[index - 1].imgUrl
                : defaultImg
            "
            alt=""
          />
        </div>
      </section>

      <!-- 一行三个 -->
      <section v-if="datas.styleType === 3" class="buju">
        <div
          v-for="index in 3"
          :key="index"
          class="rubiksCubeType_3 rubiksCubeType"
          @click="handleClickImg(index - 1)"
        >
          <!--    width: 33 - datas.imgMargin / 10 + '%', -->
          <img
            draggable="false"
            :src="
              datas.imageList[index - 1]
                ? datas.imageList[index - 1].imgUrl
                : defaultImg
            "
            alt=""
          />
        </div>
      </section>
      <!-- 一左二右 -->
      <section v-if="datas.styleType === 4" class="buju buju4">
        <div class="rubiksCubeType hw one_left_con" @click="handleClickImg(0)">
          <img
            draggable="false"
            :src="datas.imageList[0] ? datas.imageList[0].imgUrl : defaultImg"
            alt=""
          />
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
          "
        >
          <div
            v-for="index in 2"
            :key="index"
            class="hw two_top_con"
            @click="handleClickImg(index)"
          >
            <img
              draggable="false"
              :src="
                datas.imageList[index]
                  ? datas.imageList[index].imgUrl
                  : defaultImg
              "
              alt=""
            />
          </div>
        </div>
      </section>

      <!-- 一右二左 -->
      <section v-if="datas.styleType === 5" class="buju buju4">
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
          "
        >
          <div
            v-for="index in 2"
            :key="index"
            class="hw two_top_con"
            @click="handleClickImg(index - 1)"
          >
            <img
              draggable="false"
              :src="
                datas.imageList[index - 1]
                  ? datas.imageList[index - 1].imgUrl
                  : defaultImg
              "
              alt=""
            />
          </div>
        </div>
        <div class="rubiksCubeType hw one_right_con" @click="handleClickImg(2)">
          <img
            draggable="false"
            :src="datas.imageList[2] ? datas.imageList[2].imgUrl : defaultImg"
            alt=""
          />
        </div>
      </section>

      <!-- 一行四个 -->
      <section v-if="datas.styleType === 6" class="buju buju6">
        <div
          v-for="index in 4"
          :key="index"
          class="rubiksCubeType_6 rubiksCubeType"
          @click="handleClickImg(index - 1)"
        >
          <img
            draggable="false"
            :src="
              datas.imageList[index - 1]
                ? datas.imageList[index - 1].imgUrl
                : defaultImg
            "
            alt=""
          />
        </div>
      </section>

      <!-- 二左二右 -->
      <section v-if="datas.styleType === 7" class="buju">
        <div class="two_col_con">
          <div class="two_con_item two_big_con" @click="handleClickImg(0)">
            <img
              draggable="false"
              :src="datas.imageList[0] ? datas.imageList[0].imgUrl : defaultImg"
              alt=""
            />
          </div>
          <div class="two_small_con" @click="handleClickImg(1)">
            <img
              draggable="false"
              :src="datas.imageList[1] ? datas.imageList[1].imgUrl : defaultImg"
              alt=""
            />
          </div>
        </div>

        <div class="two_col_con">
          <div class="two_con_item two_small_con" @click="handleClickImg(2)">
            <img
              draggable="false"
              :src="datas.imageList[2] ? datas.imageList[2].imgUrl : defaultImg"
              alt=""
            />
          </div>
          <div class="two_big_con" @click="handleClickImg(3)">
            <img
              draggable="false"
              :src="datas.imageList[3] ? datas.imageList[3].imgUrl : defaultImg"
              alt=""
            />
          </div>
        </div>
      </section>
      <section v-if="datas.styleType === 8" class="buju">
        <div class="two_col_con">
          <div class="two_con_item two_small_con" @click="handleClickImg(0)">
            <img
              draggable="false"
              :src="datas.imageList[0] ? datas.imageList[0].imgUrl : defaultImg"
              alt=""
            />
          </div>
          <div class="two_big_con" @click="handleClickImg(1)">
            <img
              draggable="false"
              :src="datas.imageList[1] ? datas.imageList[1].imgUrl : defaultImg"
              alt=""
            />
          </div>
        </div>

        <div class="two_col_con">
          <div class="two_con_item two_big_con" @click="handleClickImg(2)">
            <img
              draggable="false"
              :src="datas.imageList[2] ? datas.imageList[2].imgUrl : defaultImg"
              alt=""
            />
          </div>
          <div class="two_small_con" @click="handleClickImg(3)">
            <img
              draggable="false"
              :src="datas.imageList[3] ? datas.imageList[3].imgUrl : defaultImg"
              alt=""
            />
          </div>
        </div>
      </section>
      <!-- 删除组件 -->
      <slot name="deles" />
    </div>
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";
export default {
  name: "Magiccube",
  props: {
    datas: Object,
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
    };
  },
  computed: {
    showimageList() {
      return this.datas.imageList.length > 0;
    },
  },
  methods: {
    handleClickImg(index) {
      // if (this.datas.imageList[index] && this.datas.imageList[index].linkUrl) {
      //   window.location.href = this.datas.imageList[index].linkUrl;
      // }
      const item = this.datas.imageList[index];
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.magiccube {
  position: relative;

  .hw {
    width: 100%;
    position: relative;
    img {
      // position: absolute;
      // top: 0;
      // left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .buju {
    display: flex;
    img {
      vertical-align: middle;
    }
    &.buju4 {
      display: flex;
      width: 100%;
      height: 256px;
      flex-direction: row;
      justify-content: space-around;
    }
    .active {
      background: #e0edff;
      border: 1px solid #155bd4;
      color: #155bd4;
      z-index: 2;
    }
    .rubiksCubeType_1 {
      width: 100%;
      height: 320px;
      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
      }
    }
    .rubiksCubeType {
      // display: inline-flex;
      // justify-content: center;
      // align-items: center;
      cursor: pointer;
      &.rubiksCubeType_2 {
        width: 49.5%;
        height: 192px;
        margin-right: 10px;
        // height: 200px;
        // &:first-of-type {
        //   img {
        //     padding-left: 0 !important;
        //     padding-top: 0 !important;
        //     padding-bottom: 0 !important;
        //   }
        // }
        &:last-of-type {
          margin-right: 0;
          // img {
          //   padding-right: 0 !important;
          //   padding-top: 0 !important;
          //   padding-bottom: 0 !important;
          // }
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      &.rubiksCubeType_3 {
        width: 33.333%;
        margin-right: 10px;
        height: 192px;
        // &:nth-of-type(1) {
        //   margin-left: 0 !important;
        //   margin-top: 0 !important;
        //   margin-bottom: 0 !important;
        // }
        // &:nth-of-type(2) {
        //   margin-top: 0 !important;
        //   margin-left: 0 !important;
        //   margin-bottom: 0 !important;
        // }
        &:nth-of-type(3) {
          margin-right: 0;
          // margin-top: 0 !important;
          // margin-right: 0 !important;
          // margin-bottom: 0 !important;
        }
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      &.rubiksCubeType_6 {
        width: 25%;
        margin-right: 10px;
        // &:nth-of-type(1) {
        //   margin-left: 0 !important;
        //   margin-top: 0 !important;
        //   margin-bottom: 0 !important;
        // }
        // &:nth-of-type(2) {
        //   margin-top: 0 !important;
        //   margin-left: 0 !important;
        //   margin-bottom: 0 !important;
        // }
        // &:nth-of-type(3) {
        //   margin-top: 0 !important;
        //   margin-left: 0 !important;
        //   margin-bottom: 0 !important;
        // }
        &:nth-of-type(4) {
          margin-right: 0;
          // margin-top: 0 !important;
          // margin-right: 0 !important;
          // margin-bottom: 0 !important;
        }
        img {
          width: 100%;
          height: 120px;
          display: block;
        }
      }

      &.one_left_con {
        margin-right: 10px;
      }
      &.one_right_con {
        margin-left: 10px;
      }
    }
    .two_col_con {
      width: 50%;
      position: relative;
      margin-right: 10px;
      .two_big_con {
        height: 192px;
      }
      .two_small_con {
        height: 112px;
      }
      .two_con_item {
        margin-bottom: 10px;
      }

      &:nth-of-type(2) {
        margin-right: 0;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
    .two_top_con {
      height: 120px;
      // &:first-of-type {
      //   padding-bottom: 5px;
      // }
      // &:last-of-type {
      //   padding-top: 5px;
      // }
    }
  }
}
</style>
